export default __webpack_public_path__ + "img/playground.6ed6e236.png";